import * as React from 'react';
import { Spinner } from '../components/ui/Spinner';

export default () => (
    <div className="login-status">
        Signing in
        <Spinner />
    </div>
)
